const baseStyles = {
  container: {
    width: '100%',
    position: 'relative',
    maxWidth: '100%'  // Match parent width
  },
  input: {
    width: '90%',
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #E5E7EB',
    borderRadius: '6px',
    color: '#374151',
    backgroundColor: '#F9FAFB',
    transition: 'all 0.2s ease',
    outline: 'none',
    marginTop: '10px'
  },
  inputFocus: {
    borderColor: '#9CA3AF',
    backgroundColor: 'white',
    boxShadow: '0 0 0 2px rgba(99, 102, 241, 0.1)'
  },
  dropdown: {
    position: 'absolute',
    top: 'calc(100% + 4px)',
    left: 0,
    right: 0,
    backgroundColor: 'white',
    borderRadius: '6px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 10
  },
  dropdownItem: {
    padding: '8px 12px',
    fontSize: '14px',
    color: '#374151',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  },
  dropdownItemHover: {
    backgroundColor: '#F3F4F6'
  },
  notFound: {
    padding: '8px 12px',
    fontSize: '14px',
    color: '#6B7280',
    fontStyle: 'italic'
  },
  select: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '14px',
    border: '1px solid #E5E7EB',
    borderRadius: '6px',
    color: '#374151',
    backgroundColor: '#F9FAFB',
    cursor: 'pointer',
    outline: 'none',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 8px center',
    backgroundSize: '20px 20px',
    boxSizing: 'border-box',  // Include padding in width calculation
    maxWidth: '100%'  // Don't exceed container width
  },
  selectedValue: {
    marginTop: '8px',
    padding: '8px 0',
    fontSize: '14px',
    color: '#374151',
  }
};

export default baseStyles;